import { StepClasskey, StyleRules } from "@material-ui/core";

export const MuiStep: Partial<StyleRules<StepClasskey, {}>> = {
  horizontal: {
    paddingLeft: "2px",
    paddingRight: "2px",
  },
};
